export default {
  name: 'SettingHexagonIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#4C8EFF'
    }
  }
};